module.exports = __webpack_public_path__ + "static/media/key.53e94eca.svg";